import { Voltage } from '../enums/voltage';

export class BaseVoltage {
    id: number = 0;
    name: string = '';
    nominalVoltage: number = 0;
    colorCode: string = '';
    voltageClass: Voltage | null = null;

    _menuOpen?: boolean = false;

    constructor(data?: any) {
        this.id = data?.id ?? null;
        this.colorCode = data?.colorCode ?? '';
        this.name = data?.name ?? '';
        this.nominalVoltage = data?.nominalVoltage ?? 0;
        this.voltageClass = data?.voltageClass ?? null;
    }
}